//--------------------------------------------
//
// Particles / Facebook Emoji
//
//--------------------------------------------

import THREE from 'three';


const Particles = (emoji, scene) => {

	const self = this;
	const geometry = new THREE.Geometry();
	const textureLoader = new THREE.TextureLoader();
	const sprite1 = textureLoader.load(emoji);


	for (let i = 0; i < 100; i++ ){
		const vertex = new THREE.Vector3();
		vertex.x = Math.random() * 2000 - 1000;
		vertex.y = Math.random() * 2000 - 1000;
		vertex.z = Math.random() * 2000 - 1000;

		geometry.vertices.push(vertex);
	}

	const parameters = [
		[sprite1, 200],
		[sprite1, 150],
		[sprite1, 125],
		[sprite1, 150],
		[sprite1, 75]
	];


	for (let p = 0; p < parameters.length; p++ ){
		let sprite = parameters[p][0];
		let size = parameters[p][1];

		let material = new THREE.PointsMaterial({
			size: size,
			map: sprite,
			depthTest: false,
			transparent: true,
			opacity: 0.8,
			blending: THREE.AdditiveBlending
		});

		let particles = new THREE.Points(geometry, material);

		particles.rotation.x = Math.random() * 2;
		particles.rotation.y = Math.random() * 2;
		particles.rotation.z = Math.random() * 6;

		scene.add(particles);
	}

}


export default Particles;